import React, { useState } from 'react';

const API = process.env.REACT_APP_API_URL || '';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPw,   setShowPw]   = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    if (!username.trim() || !password) { setError('Please enter username and password'); return; }
    setLoading(true); setError('');
    try {
      const r = await fetch(`${API}/api/login`, {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ username: username.trim(), password }),
      });
      const j = await r.json();
      if (!r.ok) { setError(j.error || 'Login failed'); return; }
      localStorage.setItem('bc_token',    j.token);
      localStorage.setItem('bc_username', j.username);
      onLogin(j.token, j.username);
    } catch (e) {
      setError('Cannot connect to server. Check your network.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-wrap">
      <div className="login-card fade-up">
        <div className="login-brand">
          <div className="login-logo">BC</div>
          <div>
            <div className="login-brand-name">BusyComp</div>
            <div className="login-brand-sub">ISSUES MONITOR</div>
          </div>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-field">
            <label className="login-label">Username</label>
            <input
              className="login-input"
              placeholder="Enter username"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
            />
          </div>

          <div className="login-field">
            <label className="login-label">Password</label>
            <div className="pw-wrap">
              <input
                className="login-input"
                type={showPw ? 'text' : 'password'}
                placeholder="Enter password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="current-password"
              />
              <button type="button" className="pw-eye" onClick={() => setShowPw(v => !v)} tabIndex={-1}>
                {showPw ? '🙈' : '👁'}
              </button>
            </div>
          </div>

          {error && (
            <div className="login-error">
              <span>⚠</span> {error}
            </div>
          )}

          <button className="login-btn" disabled={loading}>
            {loading
              ? <span style={{display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
                  <span className="spinner" style={{width:14,height:14,borderWidth:2}} /> Signing in…
                </span>
              : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
